import { Stack } from '@mui/material';
import { FeatureValueList } from '../../../classification/components/FeatureValueList';
import { IGetDealResponse } from '../../../../generated/ApiClient';

export function DealFeatureList({ deal }: { deal: IGetDealResponse }) {
  const handleRowClick = (e: React.MouseEvent<unknown>, id: string) => {
    e.stopPropagation();

    // const feature = data.find((x) => x.featureClassificationId === id);

    // if (feature) {
    //   setSelectedFeature(feature);
    //   setDialogOpen(true);
    // }
  };

  return (
    <Stack>
      <FeatureValueList
        featureValues={deal.features}
        isLoading={false}
        handleRowClick={handleRowClick}
      />
    </Stack>
  );
}
